import DashboardLayout from 'src/pages/Layout/DashboardLayout.vue';
import AuthLayout from 'src/pages/Pages/AuthLayout.vue';
import NotFound from 'src/pages/GeneralViews/NotFoundPage.vue';

const Login = () => import('src/pages/Pages/Login.vue');
const FiscalLocations = () => import('src/views/FiscalLocations.vue');
const FiscalEsirs = () => import('src/views/FiscalEsirs.vue');
const FiscalUsers = () => import('src/views/FiscalUsers.vue');
const FiscalPOS = () => import('src/views/FiscalPOS.vue');
const FiscalInvoices = () => import('src/views/FiscalInvoices.vue');
const FiscalReports = () => import('src/views/FiscalReports.vue');
const FiscalApiTokens = () => import('src/views/FiscalApiTokens.vue');
const AdminDashboard = () => import('src/views/AdminDashboard.vue');
const AdminClients = () => import('src/views/AdminClients.vue');
const AdminPayments = () => import('src/views/AdminPayments.vue');

// Auth guard - mora biti ulogovan
const requireAuth = (to, from, next) => {
    if (localStorage.getItem('fiscal_api_key')) {
        next()
    } else {
        next('/login')
    }
}

// Superadmin guard
const requireSuperAdmin = (to, from, next) => {
    if (!localStorage.getItem('fiscal_api_key')) {
        next('/login')
        return
    }
    try {
        const user = JSON.parse(localStorage.getItem('fiscal_user') || '{}')
        if (user.role === 'SUPERADMIN') {
            next()
        } else {
            next('/fiscal/locations')
        }
    } catch (e) {
        next('/login')
    }
}

const routes = [
    {
        path: '/',
        redirect: '/fiscal/locations'
    },
    {
        path: '/',
        component: AuthLayout,
        children: [
            {
                path: 'login',
                name: 'Login',
                component: Login
            }
        ]
    },
    // Fiscal (ADMIN + USER)
    {
        path: '/fiscal',
        component: DashboardLayout,
        redirect: '/fiscal/locations',
        beforeEnter: requireAuth,
        children: [
            {
                path: 'locations',
                name: 'FiscalLocations',
                components: { default: FiscalLocations }
            },
            {
                path: 'esirs',
                name: 'FiscalEsirs',
                components: { default: FiscalEsirs }
            },
            {
                path: 'users',
                name: 'FiscalUsers',
                components: { default: FiscalUsers }
            },
            {
                path: 'pos',
                name: 'FiscalPOS',
                components: { default: FiscalPOS }
            },
            {
                path: 'invoices',
                name: 'FiscalInvoices',
                components: { default: FiscalInvoices }
            },
            {
                path: 'reports',
                name: 'FiscalReports',
                components: { default: FiscalReports }
            },
            {
                path: 'api-tokens',
                name: 'FiscalApiTokens',
                components: { default: FiscalApiTokens }
            }
        ]
    },
    // Admin (SUPERADMIN)
    {
        path: '/admin',
        component: DashboardLayout,
        redirect: '/admin/dashboard',
        beforeEnter: requireSuperAdmin,
        children: [
            {
                path: 'dashboard',
                name: 'AdminDashboard',
                components: { default: AdminDashboard }
            },
            {
                path: 'clients',
                name: 'AdminClients',
                components: { default: AdminClients }
            },
            {
                path: 'payments',
                name: 'AdminPayments',
                components: { default: AdminPayments }
            }
        ]
    },
    { path: '*', component: NotFound }
];

export default routes;